import styled from '@benzinga/themetron';
import { sanitizeHTML } from '@benzinga/frontend-utils';

export interface SignUpBoxProps {
  action?: string;
  subtitle?: string;
  title?: string;
}

export const SignUpBox = ({ action, subtitle, title }: SignUpBoxProps) => {
  return (
    <SignupBoxWrapper className="signup-box" subtitle={subtitle}>
      <a
        href="https://www.benzinga.com/profile/portfolio/?action=login&utm_source=watchlist-movers"
        rel="noreferrer"
        target="_blank"
      >
        <div>
          {title ? <div className="signup-title" dangerouslySetInnerHTML={{ __html: sanitizeHTML(title) }} /> : null}
          {subtitle ? (
            <div className="signup-subtitle" dangerouslySetInnerHTML={{ __html: sanitizeHTML(subtitle) }} />
          ) : null}
          <button>{action ? action : '1 Minute Sign Up'}</button>
        </div>
      </a>
    </SignupBoxWrapper>
  );
};

export const SignupBoxWrapper = styled.div<{ subtitle: string | undefined }>`
  &.signup-box {
    align-items: center;
    border-width: 1px;
    display: flex;
    padding: ${({ theme }) => theme.space['4']};
    border-radius: ${({ theme }) => theme.borderRadius.md};
    box-shadow: ${({ theme }) => theme.shadow.md};
    border-color: ${({ theme }) => theme.colorPalette.gray300};
    background-color: #ffffff;

    &:hover {
      box-shadow: ${({ theme }) => theme.shadow.lg};
    }
    .signup-subtitle {
      color: black;
      font-size: ${({ theme }) => theme.fontSize.xl};
      padding: ${({ theme }) => theme.space['2']} 0;
    }
    .signup-title {
      font-size: ${({ theme }) => theme.fontSize['2xl']};
      font-weight: 700;
      border-bottom-width: ${({ subtitle }) => (subtitle ? '8px' : '0px')};
      border-color: ${({ theme }) => theme.colorPalette.blue500};
      color: ${({ theme }) => theme.colorPalette.black};
      padding-bottom: ${({ theme }) => theme.space['2']};
    }
    button {
      background-color: rgba(255, 123, 0, 1);
      color: white;
      display: inline-block;
      font-family: sans-serif;
      font-size: 0.875rem;
      font-weight: 600;
      height: 2.5rem;
      letter-spacing: 0.1em;
      line-height: 2.5rem;
      margin-bottom: 0;
      margin-top: 0.5rem;
      padding: 0 0.875rem;
      text-align: center;
      text-decoration: none;
      text-transform: uppercase;
      white-space: nowrap;
    }
  }
`;

export default SignUpBox;
